"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWidgetMessage = exports.widgetMessage = void 0;
const protocol_1 = require("./protocol");
const utils_1 = require("./utils");
let seed = 0;
const getMessageId = () => {
    const id = seed;
    seed++;
    return `widget-message_${Date.now()}_${id}`;
};
class WidgetMessage {
    constructor(widgetId) {
        this.target = 'main';
        /** Connect status */
        this.connect = protocol_1.ConnectStatus.CLOSED;
        this.origin = widgetId;
        this.messageBridge = protocol_1.postMessage;
    }
    /**
     * Messages in the widget, will only communicate with the main thread and will only accept messages from the main thread,
     * so simplify the parameters here.
     * @param type
     * @param callback
     */
    on(type, callback) {
        return this.messageBridge.on(type, callback, this.origin, this.target);
    }
    /**
     * Messages in the widget, will only communicate with the main thread and
     * will only accept messages from the main thread, so simplify the parameters here.
     * @param type
     * @param data
     */
    emit(type, data, messageId, allowTimeout = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.messageBridge.emit(type, Object.assign(Object.assign({}, data), { origin: this.origin }), this.target, messageId, allowTimeout);
        });
    }
    /**
     * Listening for connections.
     * @param callback
     */
    connectWidget(callback) {
        this.messageBridge.addWindow(this.target, {
            window: window.parent,
            origin: window.parent.origin
        });
        this.emit(protocol_1.MessageType.WIDGET_CONNECT, { success: true });
        this.connect = protocol_1.ConnectStatus.SYN_SENT;
        // Initializing the connection listener.
        const connectCb = () => {
            this.emit(protocol_1.MessageType.WIDGET_CONNECT_ES, { success: true });
            this.connect = protocol_1.ConnectStatus.ESTABLISHED;
            callback();
        };
        this.on(protocol_1.MessageType.MAIN_CONNECT_WIDGET, (0, utils_1.interceptor)(connectCb));
    }
    /**
     * Listening for initialization data from the main thread.
     */
    onInitWidget(callback) {
        this.on(protocol_1.MessageType.MAIN_INIT_WIDGET_DATA, (0, utils_1.interceptor)(callback));
    }
    /**
     * Listening for config update messages from the main application.
     * @param callback
     */
    onSyncWidgetConfig(callback) {
        this.on(protocol_1.MessageType.MAIN_SYNC_WIDGET_CONFIG, (0, utils_1.interceptor)(callback));
    }
    /**
     * Refresh widget.
     * @param callback
     */
    onRefreshWidget(callback) {
        this.on(protocol_1.MessageType.MAIN_REFRESH_WIDGET, (0, utils_1.interceptor)(callback));
    }
    /**
     * Listening from autonomous application action.
     * @param callback
     */
    onSyncAction(callback) {
        this.on(protocol_1.MessageType.MAIN_SYNC_ACTION, (0, utils_1.interceptor)(callback));
    }
    /**
     * Listening to the selection results from the autonomous application RecordPicker.
     * @param callback
     */
    onSyncRecordPickerResult(callback) {
        this.on(protocol_1.MessageType.MAIN_SYNC_RECORD_PICKER_RESULT, (0, utils_1.interceptor)(callback));
    }
    /**
     * Synchronize config data to the main application.
     * @param config
     */
    syncWidgetConfig(config) {
        this.emit(protocol_1.MessageType.WIDGET_SYNC_WIDGET_CONFIG, { success: true, data: config });
    }
    /**
     * Send cmd to main application.
     * @param cmdOptions
     */
    syncCmd(cmdOptions) {
        this.emit(protocol_1.MessageType.WIDGET_SYNC_COMMAND, { success: true, data: cmdOptions });
        return new Promise((resolve, reject) => {
            this.on(protocol_1.MessageType.MAIN_SYNC_COMMAND_RESULT, (res) => {
                if (res.success && res.data) {
                    resolve(res.data);
                    return;
                }
                reject(res.message);
            });
        });
    }
    /**
     * Trigger expandRecord.
     * @param expandRecordParams
     */
    expandRecord(expandRecordParams) {
        this.emit(protocol_1.MessageType.WIDGET_EXPAND_RECORD, { success: true, data: expandRecordParams });
    }
    /**
     * Expand Record Selector.
     */
    expandRecordPicker(datasheetId) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageId = getMessageId();
            return yield this.emit(protocol_1.MessageType.WIDGET_EXPAND_RECORD_PICKER, { success: true, data: datasheetId }, messageId, true);
        });
    }
    /**
     * Mouse in and mouse out widgets iframe.
     * @param type
     */
    mouseListener(type) {
        this.emit(protocol_1.MessageType.WIDGET_MOUSE_EVENT, { success: true, data: type });
    }
    /**
     * Expand to enter the developer mode pop-up window.
     */
    expandDevConfig() {
        this.emit(protocol_1.MessageType.WIDGET_EXPAND_DEV_CONFIG, { success: true });
    }
    /**
     * Loading other datasheet data.
     * @param datasheetId
     */
    fetchDatasheet(fetchDatasheet) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageId = getMessageId();
            return yield this.emit(protocol_1.MessageType.WIDGET_FETCH_DATASHEET, { success: true, data: fetchDatasheet }, messageId);
        });
    }
    /**
     * Synchronizing View Reference Count Subscription Data.
     * @param subscribeViews
     */
    syncWidgetSubscribeView(subscribeViews) {
        this.emit(protocol_1.MessageType.WIDGET_SUBSCRIBE_CHANGE, { success: true, data: subscribeViews });
    }
    removeListenEvent(type) {
        this.messageBridge.removeListenEvent(type);
    }
}
/**
 * Initialize the widget communication class,
 * you need to pass in the widgetId identifier and the current widget rendering mode.
 * @param widgetId
 * @param sandbox
 */
const initWidgetMessage = (widgetId) => {
    exports.widgetMessage = new WidgetMessage(widgetId);
    return exports.widgetMessage;
};
exports.initWidgetMessage = initWidgetMessage;
